import React from "react";
import { PackType } from "../../../utils/type";
import { ContactsOutlined, LockOutlined, UnlockOutlined } from "@ant-design/icons";

import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { Icon } from "@fluentui/react";

interface IconsandOrganizationProps {
  lockedUserEmail: string;
}

function IconsandOrganization(props: IconsandOrganizationProps) {
  const currentEmailUser = useSelector((state: RootState) => state.TranscribeState.email);
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {props.lockedUserEmail.toLowerCase() === currentEmailUser.toLowerCase() ? (
        <Icon
          iconName="Contact"
          style={{
            color: "red",
          }}
        />
      ) : props.lockedUserEmail === "" ? (
        <Icon
          iconName="unlock"
          style={{
            color: "green",
          }}
        />
      ) : (
        <Icon
          iconName="lock"
          style={{
            color: "red",
          }}
        />
      )}
    </div>
  );
}

export default IconsandOrganization;
